export default {
  path: '/withDraw',
  meta: {
    title: '提现',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/withDraw`),
}



// WEBPACK FOOTER //
// ./src/views/WithDraw/router.js